import { useState } from 'react';

export default function Contact() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        address: '',
        description: '',
    });

    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData(prev => ({ ...prev, [id]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage("");

        try {
            const response = await fetch('https://nexitus.ca/nexitus_contact_form.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    name: formData.name,
                    email: formData.email,
                    phoneNumber: formData.address, // using 'address' as phoneNumber for now
                    summary: formData.subject,
                    description: formData.description,
                    issueType: "Support",
                }),
            });

            const result = await response.json();

            if (response.ok && result.result?.ticketId) {
                setMessage(`✅ Ticket created: ${result.result.ticketId}`);
                setFormData({
                    name: '',
                    email: '',
                    subject: '',
                    address: '',
                    description: '',
                });
            } else {
                setMessage(`❌ Error: ${result.error || "Something went wrong"}`);
            }
        } catch (error) {
            setMessage("❌ Network error. Please try again later.");
            console.error("API error:", error);
        }

        setLoading(false);
    };

    const formStyle = "p-1 border border-gray-300 rounded-md mb-2";

    return (
        <div className="w-full flex justify-center">
            <div className='space-y-6 shadow-sm p-2 border border-gray-300 rounded-lg max-w-2xl w-full'>

                <div>
                    <span className="flex items-center">
                        <span className="h-px flex-1 bg-gray-300"></span>
                        <span className="shrink-0 px-4 text-white">Contact Us</span>
                        <span className="h-px flex-1 bg-gray-300"></span>
                    </span>
                </div>

                <form onSubmit={handleSubmit}>
                    {['email', 'name', 'subject', 'address', 'description'].map((field, index) => (
                        <div key={index} className={formStyle}>
                            <label htmlFor={field} className="relative block">
                                <input
                                    type="text"
                                    id={field}
                                    value={formData[field]}
                                    onChange={handleChange}
                                    required={['email', 'name', 'subject', 'description'].includes(field)}
                                    minLength={field === 'description' ? 15 : 1}
                                    placeholder=""
                                    className="peer mt-0.5 w-full rounded border-gray-300 shadow-sm sm:text-sm dark:border-gray-600 dark:bg-gray-900 dark:text-white"
                                />
                                <span className="absolute inset-y-0 start-3 -translate-y-5 bg-white px-0.5 text-sm font-medium text-gray-700 transition-transform peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-5 dark:bg-gray-900 dark:text-white">
                                    {field.charAt(0).toUpperCase() + field.slice(1)}
                                </span>
                            </label>
                        </div>
                    ))}

                    <div className="relative block mt-6">
                        <button
                            type="submit"
                            className="w-full rounded bg-teal-600 px-4 py-2 text-white hover:bg-teal-700"
                            disabled={loading}
                        >
                            {loading ? "Submitting..." : "Submit"}
                        </button>
                    </div>
                    {message && <p className="mt-4 text-sm text-center text-white">{message}</p>}
                </form>
            </div>
        </div>
    );
}
